import Home from '~/pages/Home';
import UserCadastro from '~/pages/User/UserCadastro';
import UserLista from '~/pages/User/UserLista';
import UserUpdate from '~/pages/User/UserUpdate';
import GrupoCadastro from '~/pages/Grupos/GrupoCadastro';
import GrupoLista from '~/pages/Grupos/GrupoLista';
import GrupoUpdate from '~/pages/Grupos/GrupoUpdate';
import GrupoUsuario from '~/pages/Grupos/GrupoUsuario';
import GrupoModulo from '~/pages/Grupos/GrupoModulo';
import ModuloCadastro from '~/pages/Modulos/ModuloCadastro';
import ModuloLista from '~/pages/Modulos/ModuloLista';
import ModuloUpdate from '~/pages/Modulos/ModuloUpdate';
import ModuloPaginaEspec from '~/pages/Modulos/ModuloPaginaEspec';
import ModuloMenuEspec from '~/pages/Modulos/ModuloMenuEspec';
import ModuloEmpresa from '~/pages/Modulos/ModuloEmpresa';
import PaginaCadastro from '~/pages/Paginas/PaginaCadastro';
import PaginaLista from '~/pages/Paginas/PaginaLista';
import PaginaUpdate from '~/pages/Paginas/PaginaUpdate';
import MenuCadastro from '~/pages/Menu/MenuCadastro';
import MenuLista from '~/pages/Menu/MenuLista';
import MenuUpdate from '~/pages/Menu/MenuUpdate';
import SubMenuEspec from '~/pages/Menu/SubMenuEspec';
import SubMenuCadastro from '~/pages/SubMenu/SubMenuCadastro';
import SubMenuLista from '~/pages/SubMenu/SubMenuLista';
import SubMenuUpdate from '~/pages/SubMenu/SubMenuUpdate';
import PermissaoGrupo from '~/pages/Grupos/PermissaoGrupo';

const Pages = [
  {
    name: 'home',
    route: '/',
    component: Home,
  },
  {
    name: 'User Cadastro',
    route: '/user/register',
    component: UserCadastro,
  },
  {
    name: 'User Lista',
    route: '/user/list',
    component: UserLista,
  },
  {
    name: 'User Update',
    route: '/user/update/:id',
    component: UserUpdate,
  },
  {
    name: 'Grupo Cadastro',
    route: '/group/register',
    component: GrupoCadastro,
  },
  {
    name: 'Grupo Lista',
    route: '/group/list',
    component: GrupoLista,
  },
  {
    name: 'Grupo Update',
    route: '/group/update/:id',
    component: GrupoUpdate,
  },
  {
    name: 'Grupo Modulo',
    route: '/group/modulo',
    component: GrupoModulo,
  },
  {
    name: 'Grupo Usuario',
    route: '/group/user',
    component: GrupoUsuario,
  },
  {
    name: 'Permissão Grupo',
    route: '/group/permission',
    component: PermissaoGrupo,
  },
  {
    name: 'Modulo Cadastro',
    route: '/modulo/register',
    component: ModuloCadastro,
  },
  {
    name: 'Modulo Lista',
    route: '/modulo/list',
    component: ModuloLista,
  },
  {
    name: 'Modulo Update',
    route: '/modulo/update/:id',
    component: ModuloUpdate,
  },
  {
    name: 'Modulo Pagina Especifica',
    route: '/modulo/page/:id',
    component: ModuloPaginaEspec,
  },
  {
    name: 'Modulo Menu Especifico',
    route: '/modulo/menu/:id',
    component: ModuloMenuEspec,
  },
  {
    name: 'Modulo Empresa',
    route: '/modulo/empresa/',
    component: ModuloEmpresa,
  },
  {
    name: 'Pagina Cadastro',
    route: '/page/register',
    component: PaginaCadastro,
  },
  {
    name: 'Pagina Lista',
    route: '/page/list',
    component: PaginaLista,
  },
  {
    name: 'Pagina Update',
    route: '/page/update/:id',
    component: PaginaUpdate,
  },
  {
    name: 'Menu Cadastro',
    route: '/menu/register',
    component: MenuCadastro,
  },
  {
    name: 'Menu Lista',
    route: '/menu/list',
    component: MenuLista,
  },
  {
    name: 'Menu Update',
    route: '/menu/update/:id',
    component: MenuUpdate,
  },
  {
    name: 'Menu SubMenu Especifico',
    route: '/menu/menu-sub/:id',
    component: SubMenuEspec,
  },
  {
    name: 'Sub menu Cadastro',
    route: '/menu-sub/register',
    component: SubMenuCadastro,
  },
  {
    name: 'Sub Menu Lista',
    route: '/menu-sub/list',
    component: SubMenuLista,
  },
  {
    name: 'Sub Menu Update',
    route: '/menu-sub/update/:id',
    component: SubMenuUpdate,
  },
];

export default Pages;
